















import { Component, Vue } from 'vue-property-decorator';

import { mapState, mapActions } from 'vuex';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Tab from '@/components/Tab/Tab.vue';

import { ActionTypes, State } from '@/store/disbursement';
import BalanceJumbotron from '../components/BalanceJumbotron.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Tab,
    BalanceJumbotron,
  },
  computed: mapState(['disbursement']),
  methods: mapActions({ getBalance: ActionTypes.GET_DISBURSEMENT_BALANCE }),
})
export default class CustomRequest extends Vue {
  tabs = [{
    label: 'UPLOAD DISBURSEMENT',
    to: '/auto-disbursement/upload-request/upload',
  }, {
    label: 'FAILED DISBURSEMENT',
    to: '/auto-disbursement/upload-request/re-request',
  }, {
    label: 'HISTORY',
    to: '/auto-disbursement/upload-request/report',
  }];

  disbursement!: State;
  getBalance!: () => void;

  mounted() {
    this.getBalance();
  }
}
